// Print-format foundation shared by printable documents (quotations today; invoices,
// statements, purchase orders later). Maps a user-facing choice + paper width to the
// printDoc() `format` and remembers the last choice per document type.
export const PRINT_CHOICES = [
  { id: "full", label: "Full Page / PDF", hint: "Letter / A4 layout. Save as PDF or print on a desktop printer." },
  { id: "thermal", label: "Receipt Printer", hint: "Narrow thermal roll layout. 80mm recommended." },
];
export const PAPER_WIDTHS = [
  { id: "80", label: "80mm" },
  { id: "58", label: "58mm" },
];
export const DEFAULT_PREF = { choice: "full", width: "80" };
const key = (docType) => `neec.print.${docType}.format`;

export const loadPrintPref = (docType) => {
  try { return { ...DEFAULT_PREF, ...(JSON.parse(localStorage.getItem(key(docType))) || {}) }; } catch { return { ...DEFAULT_PREF }; }
};
export const savePrintPref = (docType, pref) => { try { localStorage.setItem(key(docType), JSON.stringify(pref)); } catch { /* private mode */ } };

// -> printDoc() format id
export const resolvePrintFormat = ({ choice, width }) => (choice === "thermal" ? (width === "58" ? "thermal58" : "thermal80") : "standard");
export const isThermalFormat = (format) => format === "thermal80" || format === "thermal58";
